export default "__VITE_ASSET__0de87534__"